let globalConfig = {
  cityMap: null,
  ossUrl: "https://jintianjifen.oss-cn-shanghai.aliyuncs.com/",
}

export {
  globalConfig
}



//////////////////
// WEBPACK FOOTER
// ./config/global.js
// module id = null
// module chunks = 